import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import TrackingHistoryWidget from '../../../widgets/trackingHistoryWidgets/TrackingHistoryWidget'
import { getTrackingHistory } from '../../../redux/actions/subprojectTrackingHistory'
import { SUB_PROJECT_CODE, SUB_PROJECT_ID } from '../../../constants/constants'
import ContentHeaderWidget from '../../../components/ContentHeader/ContentHeaderWidget'

export default function TrackingHistory() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const projectCode = sessionStorage.getItem(SUB_PROJECT_CODE)
  const projectId = sessionStorage.getItem(SUB_PROJECT_ID)

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getTrackingHistory(projectCode, projectId)
      setSchema(response)
      // setSchema(mockSchema)
      // console.log('schema===>', schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProjectDep6>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProjectDep6>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isSubProjectDep6>
        <ContentHeaderWidget header={schema.header} subHeader={schema.subHeader} />

        <TrackingHistoryWidget
          schema={schema.form}
          header={schema.header}
          enableEdit={schema.enableEdit}
        />
      </SidebarProposal>
    </div>
  )
}
